<template>
  <div
    v-if="globalLoadingState"
    ref="globalLoader"
    :class="b()"
  >
    <e-progress />
  </div>
</template>

<script>
  import useSessionStore from '@/stores/session';
  import eProgress from '@/elements/e-progress.vue';

  /**
   * Renders the global loading indicator.
   */
  export default {
    name: 'c-global-loader',
    components: {
      eProgress,
    },

    // mixins: [],

    // props: {},
    setup() {
      return {
        sessionStore: useSessionStore(),
      };
    },
    data() {
      return {
        /**
         * @type {Boolean} Internally tracks the global loading state (debounce).
         */
        globalLoadingState: false,

        /**
         * @type {Number|null} Holds the global loading state debounce timeout.
         */
        globalLoadingStateTimeout: null,
      };
    },

    // computed: {},
    watch: {
      /**
       * Observes the global loading state and disables / enables the body scrolling.
       *
       * @param {Boolean} isLoading - The state of the loader.
       */
      'sessionStore.globalLoader': function (isLoading) {
        clearTimeout(this.globalLoadingStateTimeout);

        if (isLoading === this.globalLoadingState) {
          return;
        }

        this.globalLoadingStateTimeout = setTimeout(() => {
          // Smooths out multi changes.
          this.globalLoadingState = isLoading;
        }, 100);
      },

      /**
       * Tracks the internal value of global loading state to update the body scroll instance.
       *
       * @param {Boolean} isLoading - The state of the internal loader.
       */
      'globalLoadingState': function (isLoading) {
        if (isLoading) {
          this.$nextTick(() => {
            this.$bodyscroll.disableBodyScroll(this.$refs.globalLoader);
          });
        } else {
          this.$bodyscroll.enableBodyScroll(this.$refs.globalLoader);
        }
      },
    },

    // beforeCreate() {},
    // created() { },
    // beforeMount() {},
    // mounted() { },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() { },
    // unmounted() {},
    // methods: { },
    // render() {},
  };
</script>

<style lang="scss">
  @use '@/setup/scss/variables';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/functions';
  // @use '@/setup/scss/extends' as *;

  .c-global-loader {
    @include mixins.z-index(globalLoader);

    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background: rgba(variables.$color-grayscale--1000, 0.8);
    pointer-events: all;

    .e-progress {
      width: functions.rem(50px);
      height: functions.rem(50px);
    }
  }
</style>
